import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";

import {
  AuthProvider,
} from "./context/AuthContext";

import {
  Layout,
} from "./components/Layout";

import {
  ProtectedRoute,
} from "./components/ProtectedRoute";

import {
  WebAppLayout,
} from "./components/WebAppLayout";

import {
  HomePage,
} from "./pages/HomePage";

import {
  RegisterPage,
  LoginPage,
  CheckEmailPage,
  VerifyPage,
  ForgotPasswordPage,
  RecoveryPage,
} from "./pages/AuthPages";

import {
  AccountPage,
} from "./pages/AccountPage";

import {
  AdminPage,
} from "./pages/AdminPage";

import {
  FeaturesPage,
  PricingPage,
  PrivacyPage,
  TermsPage,
  SupportPage,
  NotFoundPage,
} from "./pages/StaticPages";

import {
  TodayPage,
  CalendarPage,
} from "./pages/WebAppPages";

import {
  CountdownPage,
} from "./features/countdowns";

import {
  RoutinesPage,
} from "./features/routines/RoutinesPage";

import {
  ProfilePage,
} from "./features/profile/ProfilePage";

import {
  SubscriptionPage,
} from "./features/subscription/SubscriptionPage";

import {
  EventCirclePage,
} from "./features/event-circle/EventCirclePage";

import {
  EventCircleInvitationPage,
} from "./features/event-circle/EventCircleInvitationPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route
              path="/"
              element={<HomePage />}
            />

            <Route
              path="/features"
              element={<FeaturesPage />}
            />

            <Route
              path="/pricing"
              element={<PricingPage />}
            />

            <Route
              path="/support"
              element={<SupportPage />}
            />

            <Route
              path="/privacy"
              element={<PrivacyPage />}
            />

            <Route
              path="/terms"
              element={<TermsPage />}
            />

            <Route
              path="/register"
              element={<RegisterPage />}
            />

            <Route
              path="/login"
              element={<LoginPage />}
            />

            <Route
              path="/check-email"
              element={<CheckEmailPage />}
            />

            <Route
              path="/forgot-password"
              element={<ForgotPasswordPage />}
            />

            <Route
              path="/saradium/verify"
              element={<VerifyPage />}
            />

            <Route
              path="/saradium/recovery"
              element={<RecoveryPage />}
            />

            <Route element={<ProtectedRoute />}>
              <Route
                path="/account"
                element={<AccountPage />}
              />
            </Route>

            <Route
              path="*"
              element={<NotFoundPage />}
            />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route
              path="/app"
              element={<WebAppLayout />}
            >
              <Route
                index
                element={<TodayPage />}
              />

              <Route
                path="today"
                element={<TodayPage />}
              />

              <Route
                path="routines"
                element={<RoutinesPage />}
              />

              <Route
                path="countdowns"
                element={<CountdownPage />}
              />

              <Route
                path="calendar"
                element={<CalendarPage />}
              />

              <Route
                path="event-circle"
                element={<EventCirclePage />}
              />

              <Route
                path="event-circle/invite"
                element={
                  <EventCircleInvitationPage />
                }
              />

              <Route
                path="profile"
                element={<ProfilePage />}
              />

              <Route
                path="subscription"
                element={<SubscriptionPage />}
              />
            </Route>

            <Route
              path="/admin"
              element={<AdminPage />}
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}